export default __webpack_public_path__ + "static/wrench_w.6ed74f0b4fd9ea891c5ab6af05856c1e.svg";